import UISection from 'UIComponents/section/UISection';
import FilterHeaderBar from '../filters/FilterHeaderBar';
import SaveViewButton from './SaveViewButton';
import StartTaskQueueButton from './StartTaskQueueButton';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TableHeaderBar = ({
  viewId
}) => {
  return /*#__PURE__*/_jsx(FilterHeaderBar, {
    viewId: viewId,
    endSlot: /*#__PURE__*/_jsx(Flex, {
      marginInline: "400",
      flexDirection: "row",
      alignItems: "center",
      children: /*#__PURE__*/_jsxs(UISection, {
        children: [/*#__PURE__*/_jsx(SaveViewButton, {
          viewId: viewId
        }), /*#__PURE__*/_jsx(StartTaskQueueButton, {
          viewId: viewId
        })]
      })
    })
  });
};
export default TableHeaderBar;